import { supabase, getCurrentUser } from './supabase';
import type { TodoItem } from '../types';

const TABLE = 'todos';

export async function fetchTodos(): Promise<TodoItem[]> {
  const user = await getCurrentUser();
  if (!user) throw new Error('User not authenticated');

  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .eq('user_id', user.id)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return (data || []) as TodoItem[];
}

export async function createTodo(title: string, dependsOnId?: string | null): Promise<TodoItem> {
  const user = await getCurrentUser();
  if (!user) throw new Error('User not authenticated');

  const { data, error } = await supabase
    .from(TABLE)
    .insert({
      user_id: user.id,
      title: title.trim(),
      completed: false,
      depends_on_id: dependsOnId || null,
    })
    .select()
    .single();

  if (error) throw error;
  return data as TodoItem;
}

export async function updateTodoCompleted(id: string, completed: boolean): Promise<TodoItem> {
  const { data, error } = await supabase
    .from(TABLE)
    .update({ completed })
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data as TodoItem;
}

export async function deleteTodo(id: string): Promise<void> {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);
  if (error) throw error;
}
